import { InjectionToken } from '@angular/core';

export const TRANSLOCO_LANG = /* @__PURE__ */ new InjectionToken<string>(
  ngDevMode ? 'TRANSLOCO_LANG' : '',
);
